module.exports = "<textarea name=\"tA\"  cols=\"30\" rows=\"10\" class=\"texArea\" >text:{{text}}</textarea>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/gcods/gcods.component.html
// module id = ./src/app/gcods/gcods.component.html
// module chunks = main